var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelephone = function SvgTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 513 513"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3259AA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    clipPath: "url(#telephone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.349 16.325h-160c-26.51 0-48 21.49-48 48v384c0 26.51 21.49 48 48 48h160c26.51 0 48-21.49 48-48v-384c0-26.51-21.49-48-48-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.349 16.325h24a8 8 0 0 1 8 8 16 16 0 0 0 16 16h64a16 16 0 0 0 16-16 8 8 0 0 1 8-8h24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telephone_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.349.325h512v512h-512z"
  })))));
};
export default SvgTelephone;